import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-tongue': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM312 408h0.1v-43.8l-17.7-8.8c-15.1-7.6-31.5 1.7-34.9 16.5l-2.8 12.1c-2.1 9.2-15.2 9.2-17.3 0l-2.8-12.1c-3.4-14.8-19.9-24-34.9-16.5l-17.7 8.8v42.8c0 35.2 28 64.5 63.1 65 35.8 0.5 64.9-28.4 64.9-64zM340.2 433.3c64-33.4 107.8-100.3 107.8-177.3 0-110.3-89.7-200-200-200s-200 89.7-200 200c0 77 43.8 143.9 107.8 177.3-2.2-8.1-3.8-16.5-3.8-25.3v-43.5c-14.2-12.4-24.4-27.5-27.3-44.5-1.7-10 7.8-18.4 17.7-15.3 26 8.3 64.4 13.1 105.6 13.1s79.7-4.8 105.6-13.1c10-3.2 19.4 5.4 17.7 15.3-2.9 17-13.1 32.1-27.3 44.5v43.5c0 8.8-1.6 17.2-3.8 25.3zM168 176c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM328 176c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-tongue.js
// module id = 1760
// module chunks = 0